export default __webpack_public_path__ + "static/media/man.28ec5b21.png";